// removed by extract-text-webpack-plugin
module.exports = {"wrapper-first-magazine":"magazines_21mX3","wrapper-first-magazine__content":"magazines_3d3zF","wrapper-first-magazine__content-illustration":"magazines_RZS0k","wrapper-welcome__content":"magazines_Wid9N","wrapper-welcome__content-illustration":"magazines_1UPbJ"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/FirstMagazine/styles.scss
// module id = 1263
// module chunks = 1